'use strict';

angular.module('ringbaPortal')
  .directive('trTargetsDashboard', function() {
    return {
      restrict: 'E',
      // TODO: This scope shouldn't effect the dashboard showing campaigns
      scope: {},
      controller: 'TargetsDashboardController',
      controllerAs: 'vm',
      bindToController: true,
      templateUrl: '/scripts/components/targets/targets-dashboard.view.html'
    };
  });
